import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withFlowManagerConfiguration from "../../core/components/flowManager/configuration/withFlowManagerConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import { actions as layoutsActions } from "../../core/reducers/layoutsStateReducer";

import PIXI from "pixi.js";
import { isMobile } from "react-device-detect";
import { actions as reelgridAction } from '../../core/reducers/reelgridStateReducer';
import {
    configGame
} from "../../data/config";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import { actions as baseGameAction, actions as basegameAction } from "../../core/reducers/baseGameReducer";
import { actions as freegameAction } from "../../core/reducers/freeGameReducer";
import { actions as winCelebrationActions } from "../../gamereducer/winCelebrationReducer";
import { TIMER } from "../../core/utills";
import { actions as horizontalSymbolActions } from "../../gamereducer/horizontalSymbolReducer"
import { actions as multiplierActions } from "../../gamereducer/multiplierReducer";
import { actions as winShowerActions } from "../../gamereducer/winShowerReducer";
import { actions as retriggerActions } from "../../gamereducer/retriggerReducer";
import { actions as keyboardListenerActions } from "../../core/reducers/keyboardListenerReducer";

import { actions as landingSymbolAction } from "../../core/reducers/landingsymbolreducer";
import { actions as gridsActions } from '../../core/reducers/gridStateReducer';


interface IProps {
    [x: string]: any;
}

interface IStore {
    [x: string]: any;
}

interface IStateToProps {

    reel_data: any,
    displayReelGridSymbolCount: any,
    layoutMode: string,
    callFlowManager: boolean,
    winAmount: any,
    displayInCoins: any,
    totalCreditWinAmount: any,
    currentBetIndex: any,
    featureJustReTriggered: any,
    betList: any,
    featureJustFinished: any,
    freegameSpinCountRemaining: any,
    featureType: any,
    totalCascadeCount: number,
    currentCascadeCount: number,
    freegameSpinCountWin: number,
    scatterDataBeforeFG: any,
    outroBannerSkipped: any,
    scatterDataAnticipation: any,
    inFreeGame: any,
    //selectedCoin: any,
    retriggerCount: any,
    //coinList: any,
    inAutoplay: any,
    storeAmountForAutoplay: any,
    transitionBalance: any,
    stopIfBalanceDecreasedBy: any,
    blastStart: any,
    playAnticipation: any,
    hideNegativeWins: any,
    hasCapped: any,
    clickToEnterFeature: any,
    startRandomWild: any,
    randomWildsPositions: any;
}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class GameFlowManager extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected gameFlowManagerContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;
    protected winCelebrationMinimumValue: number = 20;
    protected extraFreeSpins: number = 1;
    protected storePreviousFreeSpinCount: number = 0;
    protected constantT1: number = 100;
    protected constantT2: number = 2000;
    private bigWinTimer: number = 8000;


    constructor(props: IProps) {

        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.gameFlowManagerContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }
        this.displayUI = this.props.child.filter(this.checkUiMode.bind(this));
        this.storePreviousFreeSpinCount = this.props.freegameSpinCountWin;
    }

    //while first rendering, this method will check the mode first
    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }


    componentDidMount() {

    }

    //this method will call after the first rendering for scaling and logo animation looping
    bindUI() {


    }

    //this method will be called when a button gets clicked
    handleEvent(e: any) {

    }

    //when layout changes, this method will be called
    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }
    compare_prop_y(a: any, b: any) {
        // a should come before b in the sorted order
        if (a.y < b.y) {
            return -1;
            // a should come after b in the sorted order
        } else if (a.y > b.y) {
            return 1;
            // a and b are the same
        } else {
            return 0;
        }
    }
    returnAfterMaxClick() {
        // if (!this.props.inFreeGame) {
        //     return
        // }
        this.props.stopFreegame();
        let reelData = [
            [11, 3, 3, 7, 7, 0],
            [4, 4, 0, 8, 9, 2],
            [4, 8, 3, 3, 10, 7],
            [6, 3, 8, 8, 0, 0],
            [9, 1, 1, 3, 7, 7],
            [2, 2, 4, 10, 6, 3]
        ]
        let FWReelData;
        FWReelData = {
            stopReels: reelData,
        }

        this.props.relGridSymbolCountDisplay([3, 3, 3, 5, 6, 4])

        this.props.updateReelData(FWReelData);

        this.props.setAllButtonEnable();
        if (!this.props.inFreeGame) {
            this.props.nextAutoplay();
            this.props.nextFreegame();
        }
        else {
            this.props.setApplicationToBaseGameState(true);
        }
    }


    flowStart(nextProps: any) {

        if (nextProps.winAmount > 0) {

            let checkingCondition: boolean = true;
            let totalWinAmount = nextProps.totalCreditWinAmount;
            let storeBetValue = this.props.betList[this.props.currentBetIndex];
            if (this.props.hideNegativeWins && storeBetValue > totalWinAmount) {
                checkingCondition = false;
            }
            nextProps.stopWinPresentation();
            let nextFlowTimer = 2000;
            if (checkingCondition && nextProps.totalCreditWinAmount < this.winCelebrationMinimumValue * nextProps.betList[nextProps.currentBetIndex]) {
                if (nextProps.randomWildsPositions.length <= 0) {
                    this.props.winShowerShow(true);
                    let timer = TIMER.TimerManager.createTimer(50);
                    timer.on('end', () => {
                        this.props.winShowerStart(true, totalWinAmount);

                    });
                    timer.start();
                    nextFlowTimer = 5000;
                }
            }

            else {


                if (nextProps.totalCreditWinAmount / this.constantT1 >= this.winCelebrationMinimumValue * nextProps.betList[nextProps.currentBetIndex] / this.constantT1) {
                    if (nextProps.randomWildsPositions.length <= 0) {
                        nextProps.winCelebrationShow(true);
                        nextProps.setWinCelebrationForKeyboardListener(true);
                        let timer = TIMER.TimerManager.createTimer(this.constantT1);
                        timer.on('end', (e: any, data: any) => {
                            nextProps.winCelebrationStart(true, this.props.displayInCoins ? "Coin" : "Cash");
                        })
                        timer.start();
                        nextProps.setAllButtonDisable();
                        nextFlowTimer = this.bigWinTimer;
                    }
                }
                else {

                    if ((nextProps.inAutoplay || this.props.inAutoplay) || nextProps.featureType == "FREEGAME") {


                        nextProps.nextAutoplay();
                        nextProps.nextFreegame();
                    }
                    nextProps.setAllButtonEnable();
                }
            }

        }
        else if (nextProps.featureType == "BONUS" || nextProps.featureType == "FREEGAME") {

            if (nextProps.featureJustReTriggered) {
                this.playScatterAnimations();
                let nextSpinTimer = 2000;
                this.playScatterAnimations();
                if (this.props.retriggerCount > 0) {
                    this.props.showFeatureRetrigger();
                    nextSpinTimer = 3000;
                }
                let timer = TIMER.TimerManager.createTimer(nextSpinTimer);
                timer.on('end', (e: any, data: any) => {

                    nextProps.nextAutoplay();
                    nextProps.nextFreegame();
                })
                timer.start();

            } else {

                let timer = TIMER.TimerManager.createTimer(this.props.outroBannerSkipped ? 0 : 1500);
                timer.on('end', (e: any, data: any) => {
                    if (nextProps.featureJustFinished) {
                        let timer = TIMER.TimerManager.createTimer(this.props.outroBannerSkipped ? 0 : 5000);
                        timer.on('end', (e: any, data: any) => {

                            this.props.stopFreegame();
                            let reelData = [
                                [11, 3, 3, 7, 7, 0],
                                [4, 4, 0, 8, 9, 2],
                                [4, 8, 3, 3, 10, 7],
                                [6, 3, 8, 8, 0, 0],
                                [9, 1, 1, 3, 7, 7],
                                [2, 2, 4, 10, 6, 3]
                            ]
                            let FWReelData;
                            FWReelData = {
                                stopReels: reelData,
                            }

                            this.props.relGridSymbolCountDisplay([3, 3, 3, 5, 6, 4])

                            this.props.updateReelData(FWReelData);
                            this.props.setApplicationToBaseGameState(true);
                            if ((nextProps.totalCreditWinAmount / this.constantT1) >= this.winCelebrationMinimumValue * this.props.betList[this.props.currentBetIndex] / this.constantT1) {
                                /*   nextProps.winCelebrationShow(true);
                                  nextProps.setWinCelebrationForKeyboardListener(true);
                                  let timer = TIMER.TimerManager.createTimer(this.constantT1);
                                  timer.on('end', (e: any, data: any) => {
                                      nextProps.winCelebrationStart(true, "Cash");
                                  })
                                  timer.start(); */
                                nextProps.setAllButtonEnable();
                                let timer = TIMER.TimerManager.createTimer(this.constantT1);
                                timer.on('end', (e: any, data: any) => {
                                    if (nextProps.inAutoplay || this.props.inAutoplay) {

                                        nextProps.nextAutoplay();
                                        nextProps.nextFreegame();

                                    }
                                })
                                timer.start();
                            } else {

                                let timer = TIMER.TimerManager.createTimer(this.constantT1);
                                timer.on('end', (e: any, data: any) => {

                                    nextProps.setAllButtonEnable();
                                    if (nextProps.inAutoplay || this.props.inAutoplay) {

                                        nextProps.nextAutoplay();
                                        nextProps.nextFreegame();

                                    }
                                })
                                timer.start();

                            }

                        })
                        timer.start();

                    } else {

                        let nextSpinTimer = 0;
                        if (this.props.retriggerCount > 0) {
                            this.props.showFeatureRetrigger();
                            nextSpinTimer = 3000;
                        }

                        let timer = TIMER.TimerManager.createTimer(nextSpinTimer);
                        timer.on('end', (e: any, data: any) => {

                            nextProps.nextAutoplay();
                            nextProps.nextFreegame();

                        })
                        timer.start();


                    }
                })
                timer.start();
            }

        }
        else {



            if (nextProps.featureJustFinished) {



                let timer = TIMER.TimerManager.createTimer(this.props.outroBannerSkipped ? 0 : 5000);
                timer.on('end', (e: any, data: any) => {

                    this.props.stopFreegame();
                    let reelData = [
                        [11, 3, 3, 7, 7, 0],
                        [4, 4, 0, 8, 9, 2],
                        [4, 8, 3, 3, 10, 7],
                        [6, 3, 8, 8, 0, 0],
                        [9, 1, 1, 3, 7, 7],
                        [2, 2, 4, 10, 6, 3]
                    ]
                    let FWReelData;
                    FWReelData = {
                        stopReels: reelData,
                    }

                    this.props.relGridSymbolCountDisplay([3, 3, 3, 5, 6, 4])
                    this.props.updateReelData(FWReelData);
                    this.props.setApplicationToBaseGameState(true);
                    if ((nextProps.totalCreditWinAmount / this.constantT1) >= this.winCelebrationMinimumValue * this.props.betList[this.props.currentBetIndex] / this.constantT1) {
                        /* nextProps.winCelebrationShow(true);
                        nextProps.setWinCelebrationForKeyboardListener(true);
                        let timer = TIMER.TimerManager.createTimer(this.constantT1);
                        timer.on('end', (e: any, data: any) => {
                            nextProps.winCelebrationStart(true, "Cash");
                        })
                        timer.start(); */

                        nextProps.setAllButtonEnable();
                        let timer = TIMER.TimerManager.createTimer(this.constantT1);

                        timer.on('end', (e: any, data: any) => {
                            if (nextProps.inAutoplay || this.props.inAutoplay) {

                                nextProps.nextAutoplay();
                                nextProps.nextFreegame();

                            }
                        })
                        timer.start();
                    } else {
                        let timer = TIMER.TimerManager.createTimer(this.constantT1);
                        timer.on('end', (e: any, data: any) => {

                            nextProps.setAllButtonEnable();

                            if (nextProps.inAutoplay || this.props.inAutoplay) {

                                nextProps.nextAutoplay();
                                nextProps.nextFreegame();

                            }
                        })
                        timer.start();
                    }

                })
                timer.start();

            } else {
                let nextSpinTimer = 0;
                if (this.props.retriggerCount > 0) {
                    this.props.showFeatureRetrigger();
                    nextSpinTimer = 3000;
                }

                let timer = TIMER.TimerManager.createTimer(nextSpinTimer);
                timer.on('end', (e: any, data: any) => {

                    if ((nextProps.inAutoplay || this.props.inAutoplay) && !nextProps.startRandomWild) {

                        nextProps.nextAutoplay();
                        nextProps.nextFreegame();

                    }
                    nextProps.setAllButtonEnable();
                })
                timer.start();

            }
        }

    }


    setScatterData(reelGrid: any): any {
        let scatterPositions: any = [];
        reelGrid && reelGrid.forEach((singleReelData: any, i: any) => {
            for (let j: any = 0; j < this.props.displayReelGridSymbolCount[i]; j++) {
                if (singleReelData[j] < 72 && singleReelData[j] > 65) {
                    scatterPositions.push([i, j])
                }
            }
        });
        return scatterPositions;
    }

    // playScatterAnimations() {
    //     //let scatterPositions: any = this.setScatterDataInsideFG(this.props.scatterDataBeforeFG);
    //     let scatterPositions: any = [[0, 3-0], [0, 3-1],[0,3-2],[0,8]]

    //     let symbolBgAnimList: any = scatterPositions;
    //     this.props.setSymbolAnimationPosition([symbolBgAnimList]);
    //     let wincordinate: any = []
    //     symbolBgAnimList.forEach((data: any, index: number) => {
    //         wincordinate.push({
    //             "reelId": data[0],
    //             "rowId": data[1],
    //         })
    //     })
    //     this.props.setWinHorizontalSymbolCoOrdinate(wincordinate);
    //     this.props.playSymbolAnim();
    // }
    playScatterAnimations() {
        // let reel_data = this.props.reel_data;
        // reel_data.stopReels = reel_data.stopReelsAfterWin ? reel_data.stopReelsAfterWin : reel_data.stopReels;
        // this.props.updateReelData(reel_data);



        this.props.setLandingPosition([])


        let scatterPositions: any = this.setScatterData(this.props.scatterDataBeforeFG);
        //let scatterPositions: any = [[0, 1], [0, 2]]
        let reel_data = this.props.reel_data;
        scatterPositions.forEach((pos: any, i: any) => {
            let reelGrid = UIManager.getRef("reelgrid" + pos[0]);
            reelGrid.children.sort(this.compare_prop_y)
            reel_data.stopReels[pos[0]][pos[1]] = reelGrid.children[pos[1] + 1].symbolId;
        });
        this.props.updateReelData(reel_data);

        let symbolBgAnimList: any = scatterPositions;
        this.props.setSymbolAnimationPosition([symbolBgAnimList]);
        let wincordinate: any = []
        symbolBgAnimList.forEach((data: any, index: number) => {
            wincordinate.push({
                "reelId": data[0],
                "rowId": data[1],
            })
        })
        this.props.setWinSymbolCoOrdinate(wincordinate);
        this.props.playSymbolAnim();

    }


    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        /*   if (!nextProps.hasCapped && nextProps.hasCapped !== this.props.hasCapped) {
              this.flowStart(nextProps);
              return false;
          } */
        if (nextProps.callFlowManager !== this.props.callFlowManager) {
            // if(nextProps.freegameSpinCount !== this.props.freegameSpinCount){
            //     this.storePreviousFreeSpinCount=this.props.freegameSpinCount;
            // }

            if (nextProps.callFlowManager && !nextProps.hasCapped) {
                this.flowStart(nextProps);
                // if( nextProps.featureType == "FREEGAME"){
                if (!this.props.inFreeGame) {


                    if (nextProps.inAutoplay || this.props.inAutoplay) {
                        nextProps.setMultiplierValue(1);
                    }
                    else {
                        this.props.randomWildsPositions.length <= 0 && nextProps.setMultiplierValue(1);
                    }

                }

                // }
            }

            return false;
        }
        if (nextProps.outroBannerSkipped !== this.props.outroBannerSkipped
            || nextProps.hasCapped !== this.props.hasCapped
        ) {

            if (!nextProps.hasCapped && nextProps.hasCapped !== this.props.hasCapped) {
                this.returnAfterMaxClick();
                //this.flowStart(nextProps);
                // if( nextProps.featureType == "FREEGAME"){
                //   nextProps.activeMultiplier(true);
                // }
            }

            return false;
        }
        // blastStart: any,
        // playAnticipation: any,
        if (nextProps.blastStart !== this.props.blastStart
            || nextProps.playAnticipation !== this.props.playAnticipation) {

            if (nextProps.playAnticipation && nextProps.blastStart && nextProps.blastStart !== this.props.blastStart) {

                let timer1 = TIMER.TimerManager.createTimer(2500);
                timer1.on('end', (e: any) => {




                    let scatterPositions: any = this.setScatterData(nextProps.scatterDataAnticipation);

                    //let scatterPositions: any = [[0, 1], [0, 2]]
                    let reel_data = this.props.reel_data;
                    scatterPositions.forEach((pos: any, i: any) => {
                        let reelGrid = UIManager.getRef("reelgrid" + pos[0]);
                        reelGrid.children.sort(this.compare_prop_y);

                        reel_data.stopReels[pos[0]][pos[1]] = reelGrid.children[pos[1] + 1].symbolId;
                    });
                    this.props.updateReelData(reel_data);

                    let symbolBgAnimList: any = [];
                    for (let i = 0; i < 6; i++) {
                        let reelsInUi = UIManager.getRef("reelgrid" + i);
                        // reelsInUi.children.sort(this.compare_prop_y)
                        let countOnreel = 0;
                        for (let j: any = 0; j < reelsInUi.children.length; j++) {
                            //if (reelsInUi.children[j].symbolId > -1 && reelsInUi.children[j].symbolId < 30 && reelsInUi.children[j].y >-80 && reelsInUi.children[j].y < 616) {

                            if (reelsInUi.children[j].symbolId > -1 && reelsInUi.children[j].symbolId < 30 && reelsInUi.children[j].y > -80 && countOnreel < this.props.displayReelGridSymbolCount[i]) {
                                symbolBgAnimList.push([i, j - 1])
                            }
                            if (reelsInUi.children[j].y > -80) {
                                countOnreel++;
                            }
                        }
                    }
                    this.props.setWinSymbolCoOrdinate([]);
                    let wincordinate: any = []
                    symbolBgAnimList.forEach((data: any, index: number) => {
                        wincordinate.push({
                            "reelId": data[0],
                            "rowId": data[1],
                        })
                    })
                    this.props.setWinSymbolCoOrdinate(wincordinate);
                    this.props.playSymbolAnim();

                });
                timer1.start();

                let timer2 = TIMER.TimerManager.createTimer(4000);
                timer2.on('end', (e: any) => {
                    let symbolBgAnimList: any = [];
                    for (let i = 0; i < 6; i++) {
                        let reelsInUi = UIManager.getRef("reelgrid" + i);

                        let countOnreel = 0;
                        for (let j: any = 0; j < reelsInUi.children.length; j++) {
                            if (reelsInUi.children[j].symbolId > -1 && reelsInUi.children[j].symbolId < 30 && reelsInUi.children[j].y > -80 && countOnreel < this.props.displayReelGridSymbolCount[i]) {
                                symbolBgAnimList.push([i, j - 1])
                            }
                            if (reelsInUi.children[j].y > -80) {
                                countOnreel++;
                            }
                        }
                    }

                    this.props.setWinSymbolCoOrdinate([]);
                    let wincordinate: any = []
                    symbolBgAnimList.forEach((data: any, index: number) => {
                        wincordinate.push({
                            "reelId": data[0],
                            "rowId": data[1],
                        })
                    })
                    this.props.setWinSymbolCoOrdinate(wincordinate);
                    this.props.playSymbolAnim();

                });
                timer2.start();

            }

            return false;
        }
        /* if (nextProps.storeAmountForAutoplay - nextProps.transitionBalance / 100 >= this.props.stopIfBalanceDecreasedBy && this.props.stopIfBalanceDecreasedBy !== -1) {
            nextProps.stopAutoplay();
        } */
        return false;
    }


    render() {
        if (!this.props.callFlowManager) {
            return (<></>);
        }
        return (
            <UIManager id={"gameFlowManagerContainer"} type={"Container"} ref={i => this.gameFlowManagerContainer = i}
                name={"gameFlowManagerContainer"}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={configGame}
                            ClickHandler={this.handleEvent.bind(this)} />)
                }
            </UIManager>)
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'randomWildsState' | 'wrapperState' | 'autoplayState' | 'retriggerState' | 'betPanelState' | 'flowManagerState' | 'applicationState' | 'basegameState' | 'behaviourState' | 'freegameState' | 'reelgridState'>): IStateToProps =>
    ({
        layoutMode: state.applicationState.layoutMode,
        callFlowManager: state.flowManagerState.callFlowManager,
        winAmount: state.basegameState.winAmount,
        totalCreditWinAmount: state.behaviourState.totalCreditWinAmount,
        displayInCoins: state.behaviourState.displayInCoins,
        //currentBetIndex: state.basegameState.currentBetIndex,
        //betList: state.basegameState.betList,
        freegameSpinCountRemaining: state.freegameState.freegameSpinCountRemaining,
        featureJustReTriggered: state.freegameState.featureJustReTriggered,
        featureType: state.basegameState.featureType,
        totalCascadeCount: state.reelgridState.totalCascadeCount,
        currentCascadeCount: state.reelgridState.currentCascadeCount,
        reel_data: state.reelgridState.reel_data,
        displayReelGridSymbolCount: state.reelgridState.displayReelGridSymbolCount,
        freegameSpinCountWin: state.freegameState.freegameSpinCountWin,
        featureJustFinished: state.freegameState.featureJustFinished,
        scatterDataBeforeFG: state.behaviourState.scatterDataBeforeFG,
        outroBannerSkipped: state.behaviourState.outroBannerSkipped,
        clickToEnterFeature: state.wrapperState.clickToEnterFeature,
        scatterDataAnticipation: state.behaviourState.scatterDataAnticipation,
        inFreeGame: state.freegameState.inFreeGame,
        currentBetIndex: state.betPanelState.selectedCoin,
        betList: state.betPanelState.coinList,
        inAutoplay: state.basegameState.inAutoplay,
        storeAmountForAutoplay: state.behaviourState.storeAmountForAutoplay,
        transitionBalance: state.behaviourState.transitionBalance,
        hasCapped: state.behaviourState.hasCapped,
        stopIfBalanceDecreasedBy: state.autoplayState.stopIfBalanceDecreasedBy,
        blastStart: state.reelgridState.blastStart,
        playAnticipation: state.reelgridState.playAnticipation,
        retriggerCount: state.retriggerState.retriggerCount,
        hideNegativeWins: state.wrapperState.hideNegativeWins,
        startRandomWild: state.randomWildsState.startRandomWild,
        randomWildsPositions: state.randomWildsState.randomWildsPositions,


    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationToBaseGameState: (basegamestate: boolean): any => dispatch(basegameAction.setApplicationToBaseGameState(basegamestate)),
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutsActions.setApplicationLayoutObject(layoutobjectlist)),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        nextAutoplay: (): any => dispatch(basegameAction.nextAutoplay()),
        nextFreegame: (): any => dispatch(freegameAction.nextFreegame()),
        winCelebrationStart: (startWinCelebration: boolean, showAmount: string): any => dispatch(winCelebrationActions.winCelebrationStart(startWinCelebration, showAmount)),
        winCelebrationShow: (showWinCelebration: boolean): any => dispatch(winCelebrationActions.winCelebrationShow(showWinCelebration)),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        activeMultiplier: (multiplierActive: boolean): any => dispatch(multiplierActions.activeMultiplier(multiplierActive)),
        setWinSymbolCoOrdinate: (winSymbolCoOrdinate: any): any => dispatch(winpresentationAction.setWinSymbolCoOrdinate(winSymbolCoOrdinate)),
        playSymbolAnim: (): any => dispatch(winpresentationAction.playSymbolAnim()),
        setSymbolAnimationPosition: (symbolAnimationPosition: any): any => dispatch(winpresentationAction.setSymbolAnimationPosition(symbolAnimationPosition)),
        updateReelData: (result_reel: any): any => dispatch(gridsActions.updateReelData(result_reel)),
        setWinHorizontalSymbolCoOrdinate: (winSymbolCoOrdinate: any): any => dispatch(horizontalSymbolActions.setWinSymbolCoOrdinate(winSymbolCoOrdinate)),
        stopFreegame: (): any => dispatch(freegameAction.stopFreegame()),
        winShowerStart: (startWinShower: boolean, winShowerAmount: number): any => dispatch(winShowerActions.winShowerStart(startWinShower, winShowerAmount)),
        winShowerShow: (showWinShower: boolean): any => dispatch(winShowerActions.winShowerShow(showWinShower)),
        stopAutoplay: (): any => dispatch(baseGameAction.stopAutoplay()),
        setWinCelebrationForKeyboardListener: (winCelebrationForKeyBoardListener: boolean): any => dispatch(keyboardListenerActions.setWinCelebrationForKeyboardListener(winCelebrationForKeyBoardListener)),
        setMultiplierValue: (multiplierCurrentValue: any): any => dispatch(multiplierActions.setMultiplierValue(multiplierCurrentValue)),

        setLandingPosition: (landingPosition: any): any => dispatch(landingSymbolAction.setLandingPosition(landingPosition)),
        relGridSymbolCountDisplay: (displayReelGridSymbolCount: any): any => dispatch(gridsActions.relGridSymbolCountDisplay(displayReelGridSymbolCount)),
        showFeatureRetrigger: (): any => dispatch(retriggerActions.showFeatureRetrigger()),

    }))(withFlowManagerConfiguration(GameFlowManager)));